export const extractAddress = ({
  user,
  isCustomer,
}: {
  user: any;
  isCustomer: boolean;
}) => {
  if (isCustomer) {
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      addressLine1: user.addressLine1,
      addressLine2: user.addressLine2,
      addressLocality: user.addressLocality,
      addressPostcode: user.addressPostcode,
      country: 'DE',
      company: '',
    };
  } else {
    return {
      firstName: user.givenName,
      lastName: user.familyName,
      addressLine1: user.primaryAddress.addressLine1,
      addressLine2: user.primaryAddress.addressLine2,
      addressLocality: user.primaryAddress.addressLocality,
      addressPostcode: user.primaryAddress.addressPostcode,
      country: 'DE',
      company: '',
    };
  }
};

export const reformatOrderAddress = (address: any) => {
  return {
    firstName: address.firstName,
    lastName: address.lastName,
    addressLine1: address.addressLine1,
    addressLine2: address.addressLine2,
    addressLocality: address.addressLocality,
    addressPostcode: address.addressPostcode,
    country: 'DE',
    company: '',
    id: address.id,
  };
};
